import One from './One';
import Two from './Two';
import Four from './Four';
import Five from './Five';

export default [One, Two, Four, Five];
